import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPermissionsEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-permissions-edit',
	path: '/secure/admin/EditPermissions([!%]?[\\w]*).jspa',
};
